<template>
<ValidationObserver ref="observer" v-slot="{ invalid }">
    <div>
        <message-component id="message" v-model="isMessage" :success="message.success">{{ message.text }}</message-component>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <label-component fontSize="35" fontWeight="bold" style="margin-top: 30px;">パスワード再設定</label-component>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <label-component>新しいパスワード</label-component>
            </v-col>
            <v-col cols="12" xl="3">
                <ValidationProvider name="パスワード" rules="required|min:8" vid="password" v-slot="{ errors }">
                    <v-text-field outlined clearable v-disabled-icon-focus v-model="password" type='password' hint="大文字、小文字、数字、記号を含む8文字以上でご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                </ValidationProvider>
            </v-col>
            <v-col cols="12" xl="2">
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <label-component>新しいパスワード（確認）</label-component>
            </v-col>
            <v-col cols="12" xl="3">
                <ValidationProvider name="パスワード" rules="required|min:8|confirmed:password" v-slot="{ errors }">
                    <v-text-field outlined clearable v-disabled-icon-focus v-model="password_confirm" type='password' hint="大文字、小文字、数字、記号を含む8文字以上でご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                </ValidationProvider>
            </v-col>
            <v-col cols="12" xl="2">
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <button-component block color="red" @click="password_reset" :disabled="invalid">パスワード設定</button-component>
            </v-col>
        </v-row>
    </div>
</ValidationObserver>
</template>

<script>
    export default {
        props: ['reset_key'],
        data: function () {
            return {
                password: null,
                password_confirm: null,
                 // メッセージ
                message: {
                    success: false,
                    text: '',
                },
            }
        },
        methods: {
            password_reset: async function (event) {
                var res = await axios.post(
                    '/documents/password_reset_update',
                    {
                        'key': this.reset_key,
                        'password': this.password,
                        'password_confirm': this.password_confirm,
                    }
                )
                .catch(res => {
                  // console.log(res);
                    this.success = false;
                    this.message = "処理に失敗しました";
                });
                if (res.data.message) {
                    this.message.success = res.data.success;
                    this.message.text = res.data.message;
                }
                if (res.data.success) {
                    if ('redirect' in res.data) {
                        window.location = res.data.redirect;
                    } else {
                        window.location = "login?type=password_reset_complete";
                    }
                }
            }
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
    }
</script>